import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import Auth from "./modules/Auth.store"
import Med from "./modules/Med.store"
import MedGroup from "./modules/MedGroup.store"
import Common from "./modules/Common.store";

Vue.use(Vuex)

const modules = {
  Auth: Auth,
  Med: Med,
  MedGroup: MedGroup,
  Common: Common,
}

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState()]
})
